import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";

import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import Button from "../elements/Button";
import ReactPlayer from "react-player/youtube";

//import Fire base
import { db } from "../../firebase-config";
import {  doc, getDoc } from "firebase/firestore";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const { uid } = useParams();
  const location = useLocation();
  const [dynamicLink, setDynamicLink] = useState("");
  const [name, setName] = useState("");

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const [youtubevideo, setyoutubevideo] = useState({});

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setDynamicLink(queryParams.get("dynamicLink"));
    setName(queryParams.get("name"));

    const getVideoDetails = async () => {
      const data = await getDoc(doc(db, "distributor-links", uid));
      setyoutubevideo(data.data());
    };

    getVideoDetails();
  }, [location.search,uid]);

  function handleDynamicLink(){
    window.location.href = dynamicLink;
  }

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h2
              className="mt-0 mb-16 reveal-from-bottom"
              data-reveal-delay="200"
            >
              {youtubevideo?.videotitle}
            </h2>
          </div>
          <div
            className="hero-figure reveal-from-bottom illustration-element-01"
            data-reveal-value="20px"
            data-reveal-delay="800"
          >
            <div>
              {youtubevideo?.videourl ? (
                <div>
                  <p><b>English</b></p>
                  <ReactPlayer
                  url={youtubevideo?.videourl}
                  controls
                  width="100%"
                  style={{ height: "50vh" }}
                />
                </div>
              ) : (
                <div className="hero-content">
                  <h1>Please wait ...</h1>
                </div>
              )}
            </div>
            <br></br>

            <div>
              {youtubevideo?.videourl_hindi ? (
                <div>
                  <p><b>Hindi</b></p>
                  <ReactPlayer
                    url={youtubevideo?.videourl_hindi}
                    controls
                    width="100%"
                    style={{ height: "50vh" }}
                  />
                </div>
              ) : (
                <div className="hero-content">
                </div>
              )}
            </div>
            <br></br>
            <div>
              {youtubevideo?.videourl_tamil ? (
                <div>
                  <p><b>Tamil</b></p>
                  <ReactPlayer
                    url={youtubevideo?.videourl_tamil}
                    controls
                    width="100%"
                    style={{ height: "50vh" }}
                  />
                </div>
              ) : (
                <div className="hero-content">
                </div>
              )}
            </div>
          </div>
          <div className="container-xl mt-32">
            {dynamicLink && name ? (
              <p style={{fontWeight:"bold"}}>
                {" "}
                <span className="text-color-primary">{name.charAt(0).toUpperCase()+name.substring(1)}</span> invites
                you to download and signup for the app called Miracle by Rapid
                Mind Power. Read the following description and watch the
                complete video carefully before you proceed with signing up. To
                signup, find the link below at the end of the description.{" "}
              </p>
            ) : (
              ""
            )}
            <p
              className="m-0 mt-32 reveal-from-bottom"
              data-reveal-delay="400"
              style={{ textAlign: "justify" }}
            >
              {youtubevideo?.description}
            </p>
            <Button style={{ marginTop: "20px" }} onClick={handleDynamicLink} color="primary" wideMobile>
              Download & SignUp
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
